import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InviteWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '4px',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));
export const StyledInviteBtn = styled(Button)(({ theme }) => ({
  width: '100%',
  // height: '50px',
  color: '#f6bf41',
  padding: '4px 8px',
  background: theme.palette.bg.form,
  boxShadow: '0px -10px 4px 0px rgba(0, 0, 0, 0.50) inset',
  border: '1px solid #8a8a98',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  // marginTop: theme.spacing(2),
  '&:hover': {
    filter: 'brightness(1.2)',
    // background: '#16161B',
  },
  // [theme.breakpoints.down('md')]: {
  //   display: 'none',
  // },
}));

export const InviteBannerWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(3),
  background: '#17181B',
  display: 'flex',
  justifyContent: 'center',
}));

export const InviteContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.spacing(2),
  width: '228px',
}));

export const ShareLinkWrapper = styled(Box)(({ theme }) => ({}));
export const LinkWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[1000],
  height: '48px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '12px',
  paddingRight: '8px',
  marginTop: '11px',
  color: theme.palette.grey[600],
}));

// export const Typography
export const InviteIconWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(2),
  top: '104px',
  zIndex: 999,
  '& .MuiBox-root': {
    boxShadow:
      '0px 3.75px 1.25px -2.5px rgba(0, 0, 0, 0.20), 0px 2.5px 2.5px 0px rgba(0, 0, 0, 0.14), 0px 1.25px 6.25px 0px rgba(0, 0, 0, 0.12)',
  },
  [theme.breakpoints.down('md')]: {
    top: theme.spacing(9),
    left: theme.spacing(1),
  },
}));
